import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { NotificationsService } from 'angular2-notifications';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AdminService } from "../services/admin.service";

@Component({
    selector: 'app-deposit-address',
    templateUrl: './deposit-address.component.html',
    styleUrls: ['./deposit-address.component.css']
})
export class depositAddressComponent implements OnInit {
    depositAddress:any;
    userid:any;
    displayedColumns = ['vaultId','assetId','currency', 'address', 'legacyAddress', 'destinationTag'];
    dataSource: MatTableDataSource<depositData>;
    pageSize = 25;
    depositRes:any
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private route: ActivatedRoute, 
        private userService: UserService,
        private adminService: AdminService,
        private notifSer: NotificationsService,
        ) { }

    ngOnInit() {
        this.userid = this.route.snapshot.paramMap.get('id');
        if (this.userid) {
            this.userService.csrf().subscribe((success) => {
                this.adminService.getDepositAddresses(0, 0, this.userid, success['_csrf']).subscribe(depositAddresses => {
                    this.depositAddress = depositAddresses.addresslist;
                    let tableData = [];
                    for (const depositAddress of this.depositAddress) {
                        tableData.push({
                            vaultId: depositAddress.vault_id, 
                            assetId: depositAddress.assetId,
                            currency: depositAddress.currency, 
                            address: depositAddress.address,
                            legacyAddress: depositAddress.legacyAddress,
                            destinationTag: depositAddress.tag,
                        });
                    }
                    this.dataSource = new MatTableDataSource(tableData);                    
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                })
            });

        }

    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
}
export interface depositData  {
    vaultId: string,
    assetId: string,
    currency: string,
    address: string,
    destinationTag: string,
    legacyAddress: string,
}


// WEBPACK FOOTER //
// ./src/app/deposit-address/deposit-address.component.ts